var $ = require('jQuery');
var Vue = require('vue');
var Leaderboard = require('./Leaderboard.vue').default;
var Columnator = require('../../lib/columnator.js');
var IndexView = require('../../lib/index-view.js');

module.exports = function() {
  const leaderboard = new Vue({
    el: '#leaderboard',
    components: {
      'leaderboard': Leaderboard
    }
  });

  $(document).one('pjax:end', () => {
    leaderboard.$destroy();
  });

  new IndexView();
  new Columnator();
};
